import Swal from 'sweetalert2';
import './bootstrap';

document.addEventListener('livewire:init', function () {
    Livewire.on('swal-redirect', ([data]) => {
        Swal.fire(data.options)
            .then(res => {
                if (res.isConfirmed) {
                    window.location.href = data.route
                }
            })
    })

    Livewire.on('swal', ([options]) => Swal.fire(options))

    Livewire.on('redirect', ([options]) => {
        setTimeout(() => {
            window.location.href = options['route']
        }, options['delay'] ?? 0)
    })
});